import React, { useEffect, FC } from 'react';
import { observer } from 'mobx-react-lite';
// @ts-ignore
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useStores } from 'hooks/useStores';
import isEmpty from 'lodash/isEmpty';
import SkeletonMiniCard from 'generic/SkeletonMiniCard';
import MiniCard from '../MiniCard2';

import { ListMiniCardsStyles } from './ListMiniCardsStyles';

interface Props {
  adverts: [any];
  accounts: any;
  loading: any;
}

const ListingMiniCards: FC<Props> = observer(({ adverts, accounts, loading }) => {
  const {
    advertsStore,
    pagesStore: { currentPage },
  } = useStores();

  useEffect(() => {
    advertsStore.setMiniCardAnimation(true);
  }, []);

  return (
    <>
      {(!isEmpty(adverts) || !isEmpty(accounts)) && (
        <ListMiniCardsStyles>
          <TransitionGroup exit={advertsStore.isMiniCardAnimation}>
            {adverts?.map((advert: any) => (
              <CSSTransition key={advert._id} timeout={300} classNames="card">
                {!loading ? (
                  // @ts-ignore
                  <MiniCard
                    advertData={advert}
                    accountData={accounts[advert.owner_acc]}
                    page={currentPage}
                  />
                ) : (
                  <SkeletonMiniCard />
                )}
              </CSSTransition>
            ))}
          </TransitionGroup>
        </ListMiniCardsStyles>
      )}
    </>
  );
});

export default ListingMiniCards;
